import { Component, ElementRef, Input, OnChanges, OnInit, ViewChild } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { XsellService } from 'src/app/billers/services/xsell.service';
import { AnalyticsService } from 'src/app/core/services/analytics-service';
import { DialogService } from 'src/app/core/services/dialog.service';
import { PaymentService } from 'src/app/pay/services/payment.service';
import { TypeformService } from 'src/app/shared/services/typeform.service';
import { LiabilityActions } from '../../classes/liability-actions';
import { Liability } from '../../models/liability.model';
import { LiabilityService } from '../../services/liability.service';
import { LiabilityApiService } from '../../services/liability-api.service';
import { LiabilityItemService } from '../../services/liability-item.service';
import { LiabilityMenuDisabledState } from '../../models/model';
import { AppConfig } from '../../../core/services/app-config.service';
import { CartStoreService } from '../../../shared/services/cart.service';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { IconComponent } from '../../../shared/components/icon/icon.component';
import { ApiCallLoadingDirective } from '../../../shared/directives/api-call-loading.directive';
import { NgIf } from '@angular/common';
import { MatIconButton } from '@angular/material/button';

@Component({
  standalone: true,
  selector: 'app-expandable-menu-vertical',
  styleUrls: ['./expandable-menu-vertical.component.scss'],
  templateUrl: './expandable-menu-vertical.component.html',
  imports: [
    MatMenuTrigger,
    IconComponent,
    MatMenu,
    ApiCallLoadingDirective,
    RouterLink,
    MatMenuItem,
    NgIf,
    MatIconButton,
  ],
})
export class ExpandableMenuVerticalComponent extends LiabilityActions implements OnChanges, OnInit {
  @ViewChild('downloadPdfLink', { static: true }) public downloadPdfLink: ElementRef;
  liabilityMenuDisabled = false;
  @Input() public liability: Liability = null;
  @Input() public showDetails: boolean = false;
  @Input() public startedPaymentId: string = null;

  constructor(
    router: Router,
    liabilityService: LiabilityService,
    paymentService: PaymentService,
    analyticsService: AnalyticsService,
    xsellService: XsellService,
    dialog: DialogService,
    snackbar: MatSnackBar,
    route: ActivatedRoute,
    typeformService: TypeformService,
    liabilityApiService: LiabilityApiService,
    liabilityItemService: LiabilityItemService,
    appConfig: AppConfig,
    cartStoreService: CartStoreService
  ) {
    super(
      liabilityService,
      paymentService,
      analyticsService,
      xsellService,
      dialog,
      snackbar,
      router,
      route,
      typeformService,
      liabilityApiService,
      liabilityItemService,
      appConfig,
      cartStoreService);
    liabilityItemService.liabilityItemMenuDisabled$.subscribe(
      (newState) => (this.liabilityMenuDisabled = LiabilityMenuDisabledState.DISABLED === newState),
    );
  }

  public ngOnInit(): void {
    this.calculateActions();
  }

  public ngOnChanges(): void {
    this.calculateActions();
  }

  public canShowDetails(): boolean {
    return false;
  }
}
